import React, { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Aos from "aos";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";

import "aos/dist/aos.css";
import "./App.css";

import Navbar from "./components/Navbar";
import Loader from "./components/Loader";

import * as Actions from "./redux/actions";
import { env } from "./config";

import {
  Home,
  TelecomPage,
  SmartCityPage,
  BlogPage,
  CareerPage,
  CareerIndividualPage,
  NsepPage,
  ContactPage,
  AgroTechPage,
  IndividualBlog,
  IoTdDevelopmentPage,
  FarmToPlatePage,
  SafetyAndMonitoringForBargesPage,
  ProductDevelopmentPage,
  ApplicationDevelopmentPage,
  EcommerceDevelopmentPage,
  CloudServicesPage,
  QualityAssurancePage,
  TelecomSystemPage,
  ItConsultingPage,
  DigitalTransfromationPage,
  ItConsultingHomePage,
  CloudSolutionsPage,
  DevopsandIntegrationPage,
  EthnicDayPage,
  CompanyPage,
  FinancePage,
  DataAnalyticsPage,
  WebsiteDevelopmentLandingPage,
  MobileAppDevelopmentLandingPage,
  WikipeedikaPage,
  WikipeedikaIndividualBlogPage,
  PrivacyPolicy,
  NcsPage,
  NcsIndividualPage,
  NcsContact,
  PeojectCommunityCommerce,
  OffshoreWindpage,
  Whitepaper,
  WhitePaperIndividualPage,
  EventPage,
  EventIndividualPage,
  Ai,
  SmsOptInPage,
} from "./Pages/index";
import { ModernSlaveryPolicy } from "./Pages/ModernSlaveryPolicy";
import { SocialMediaPolicy } from "./Pages/SocialMediaPolicy";
import { WhistleblowerPolicy } from "./Pages/WhistleblowerPolicy";
import { SmsTermsAndConditions } from "./Pages/SmsTermsAndCondititonsPage";
import CloudStackPage from "./Pages/CloudStackPage";

function App() {
  const dispatch = useDispatch();

  const BlogPages = useSelector((state: any) => state?.Page?.BlogContent);

  const getBlogContent = () => {
    axios.get(`${env}/api/blogs?populate=deep`).then((res) => {
      dispatch(Actions.BlogContentAction(res.data?.data));
    });
  };

  useEffect(() => {
    Aos.init({
      duration: 1000,
      useClassNames: true,
      animatedClassName: "animated",
    });
    Aos.refresh();
  }, []);

  useEffect(() => {
    if (!Object.keys(BlogPages).length) getBlogContent();
  }, []);

  return (
    <div>
      <Toaster />
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/products" element={<TelecomPage />} />
          <Route path="/smartcity" element={<SmartCityPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:key" element={<IndividualBlog />} />
          <Route path="/whitepaper" element={<Whitepaper />} />
          <Route
            path="/whitepaper/:key"
            element={<WhitePaperIndividualPage />}
          />
          <Route path="/life@netstratum" element={<CareerPage />} />
          <Route path="/careers" element={<CareerPage />} />
          <Route path="/careerapply" element={<CareerIndividualPage />} />
          <Route path="/careerapply/:key" element={<CareerIndividualPage />} />
          <Route path="/nsep" element={<NsepPage />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/agrotech" element={<AgroTechPage />} />
          <Route path="/iot" element={<IoTdDevelopmentPage />} />
          <Route path="/iot/netfarm" element={<FarmToPlatePage />} />
          <Route path="/iot/offshorewind" element={<OffshoreWindpage />} />
          <Route
            path="/iot/bargesolutions"
            element={<SafetyAndMonitoringForBargesPage />}
          />
          <Route
            path="/product-development"
            element={<ProductDevelopmentPage />}
          />
          <Route
            path="/product-development/application-development"
            element={<ApplicationDevelopmentPage />}
          />
          <Route
            path="/product-development/ecommerce-development"
            element={<EcommerceDevelopmentPage />}
          />
          <Route
            path="/product-development/cloud-services"
            element={<CloudServicesPage />}
          />
          <Route
            path="/product-development/qualityassurance&testing"
            element={<QualityAssurancePage />}
          />
          <Route
            path="/product-development/telecom-system"
            element={<TelecomSystemPage />}
          />
          <Route
            path="/product-development/it-consulting"
            element={<ItConsultingPage />}
          />
          <Route
            path="/digital-transformation"
            element={<DigitalTransfromationPage />}
          />
          <Route path="/it-consulting" element={<ItConsultingHomePage />} />
          <Route path="/cloudandintegrations" element={<CloudSolutionsPage />} />
          <Route
            path="/devopsandintegration"
            element={<DevopsandIntegrationPage />}
          />

          <Route
            path="/cloudstack"
            element={<CloudStackPage />}
          />
          <Route path="/ai" element={<Ai />} />
          <Route
            path="/life@netstratum/ethnicday"
            element={<EthnicDayPage />}
          />
          <Route path="/company" element={<CompanyPage />} />
          <Route path="/finance" element={<FinancePage />} />
          <Route path="/data-analytics" element={<DataAnalyticsPage />} />
          <Route
            path="/lp/website-development"
            element={<WebsiteDevelopmentLandingPage />}
          />
          <Route
            path="/lp/mobile-app-development"
            element={<MobileAppDevelopmentLandingPage />}
          />
          <Route path="/wikipeedika" element={<WikipeedikaPage />} />
          <Route
            path="/wikipeedika/:key"
            element={<WikipeedikaIndividualBlogPage />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/Privacy_Policy.html" element={<PrivacyPolicy />} />


          <Route path="/sms-terms-and-conditions" element={<SmsTermsAndConditions />} />
          <Route path="/SMS_Terms.html" element={<SmsTermsAndConditions />} />
          <Route path="/sms-opt-in" element={<SmsOptInPage />} />
          <Route path="/sms-opt-in.html" element={<SmsOptInPage />} />
          <Route path="/SMS_Opt_In.html" element={<SmsOptInPage />} />


          <Route path="/social-media-policy" element={<SocialMediaPolicy />} />
          <Route path="/whistleblower-policy" element={<WhistleblowerPolicy />} />
          <Route path="/modern-slavery-policy" element={<ModernSlaveryPolicy />} />


          <Route path="/ncs" element={<NcsPage />} />
          <Route path="/ncs/:key" element={<NcsIndividualPage />} />
          <Route path="/ncs/contact" element={<NcsContact />} />
          <Route path="/paystratum/contact" element={<NcsContact />} />
          <Route
            path="/finance/projectcommunitycommerce"
            element={<PeojectCommunityCommerce />}
          />
          <Route path="/events" element={<EventPage />} />
          <Route path="/events/:key" element={<EventIndividualPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
